import { render, staticRenderFns } from "./PositionItem.vue?vue&type=template&id=0a9fb793&scoped=true&"
import script from "./PositionItem.vue?vue&type=script&lang=js&"
export * from "./PositionItem.vue?vue&type=script&lang=js&"
import style0 from "./PositionItem.vue?vue&type=style&index=0&id=0a9fb793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9fb793",
  null
  
)

export default component.exports